<template>
    <header class="header">
        <div class="container-fluid">
            <nav class="navbar navbar-expand-lg header-nav">
                <div class="navbar-header">
                    <a id="mobile_btn" href="javascript:void(0);">
                        <span class="bar-icon">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </a>
                    <router-link :to="{ name: 'HomePage'}" class="navbar-brand logo">
                        <img :src="companyLogo" class="img-fluid" alt="Logo">
                    </router-link>
                    <router-link :to="{ name: 'HomePage'}" class="navbar-brand logo-small">
                        <img :src="companyLogo" class="img-fluid" alt="Logo">
                    </router-link>

                </div>
                <div class="main-menu-wrapper">
                    <div class="menu-header">
                        <a href="" class="menu-logo">
                            <img :src="companyLogo" class="img-fluid" alt="Logo">
                        </a>
                        <a id="menu_close" class="menu-close" href="javascript:void(0);"> <i class="fas fa-times"></i></a>
                    </div>
                    <ul class="main-nav">

                        <li  id="mobile-logout" class="username-mobile-login" v-if="isUserLoggedIn" ><span v-if="name!='' && name!=null">
                            <b>Welcome</b>{{name.firstName}} {{name.lastName}}</span>
                        </li>

                        <li v-for="link in NavLinks">
                            <router-link class="nav-link" :to="{ name: link.routeUrl,params:link.params}">{{link.displayText}}</router-link>
                            <!--<router-link :to="{name:'HomePage'}">
            Home
        </router-link>-->
                        </li>
                        <!--<li>

        <router-link :to="{name:'Aboutus'}">
            About Us
        </router-link>

    </li>
    <li>

        <router-link :to="{name:'GolfCartListing'}">
            Golf Carts
        </router-link>

    </li>


    <li>

        <router-link :to="{name:'Blog'}">
            Blogs
        </router-link>

    </li>



    <li>

        <router-link :to="{name:'ContactUs'}">
            Contact
        </router-link>

    </li>-->


                        <li class="has-submenu" v-if="isUserLoggedIn">
                            <a href="#/dashboard">{{$t('StoreFront.MyAccount')}} <i class="fas fa-chevron-down"></i></a>
                            <ul class="submenu">

                                <li><a class="nav-link" href="javascript:;" @click="goToPortalDashboard">{{$t('StoreFront.GoToPortal')}}</a></li>


                                  <!--<li><a href="user-settings.html">Settings</a></li>--> 
                            </ul>
                        </li>
                        <li id="mobile-logout" class="nav-item " v-if="isUserLoggedIn">
                            <a class="nav-link header-reg" routerlinkactive="active" @click="this.$emit('logout')" ng-reflect-router-link-active="active"><span><i class="fa-solid fa-lock"></i></span> {{$t('StoreFront.Logout')}}</a>
                        </li>
                        <li class="nav-item hidedesktopmenu mobile-left-icon" v-if="!isUserLoggedIn">
                            <a class="nav-link header-login" href="Javascript:void(0)" @click="$emit('openLoginPage')"><span><i class="fa-regular fa-user"></i></span> Sign In</a>
                        </li>
                        <li class="nav-item hidedesktopmenu mobile-left-icon" v-if="!isUserLoggedIn">
                            <router-link :to="{name:'SignupPage'}" @click="OpenRightMenu" class="nav-link header-reg">
                                <span><i class="fa-solid fa-lock"></i></span> Sign Up
                            </router-link>
                        </li>


                        <!-- <li class="login-link" v-if="!isUserLoggedIn">

        <router-link :to="{name:'SignupPage'}" @click="OpenRightMenu">
            Sign Up
        </router-link>
    </li>
    <li class="login-link" v-if="!isUserLoggedIn">
        <a href="Javascript:void(0)" @click="$emit('openLoginPage')">Sign In</a>
    </li> --->
                    </ul>
                </div>
                <ul class="nav header-navbar-rht" v-if="isUserLoggedIn">
                    <li class="nav-item " v-if="name!='' && name!=null"><b>Welcome</b>&nbsp;{{name.firstName}} {{name.lastName}}</li>
                    <li class="nav-item ">
                        <a class="nav-link header-reg" routerlinkactive="active" @click="this.$emit('logout')" ng-reflect-router-link-active="active"><i class="fa-solid fa-lock"></i> {{$t('StoreFront.Logout')}}</a>
                    </li>
                </ul>

                <ul id="logout_navigation" class="nav header-navbar-rht" v-if="!isUserLoggedIn">
                    <li class="nav-item">
                        <a class="nav-link header-login" href="Javascript:void(0)" @click="$emit('openLoginPage')"><span><i class="fa-regular fa-user"></i></span>Sign In</a>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name:'SignupPage'}" @click="OpenRightMenu" class="nav-link header-reg">
                            <span><i class="fa-solid fa-lock"></i></span>Sign Up
                        </router-link>
                    </li>
                </ul>


            </nav>
        </div>
    </header>

</template>

<script>
    import { ref } from 'vue'
    import service from '@/Services/frontEndService.js'
    export default {
        components: {

        },
        name: 'HeaderVue',
        props: ['NavLinks', 'isUserLoggedIn', 'name'],
        emits: ["openSignUpdmodel", "openLoginModel", "logout"],

        data() {
            const isTextRed = ref(false)
            const isText = ref(false)
            function menutoggle() {
                isTextRed.value = !isTextRed.value;
                document.getElementById("nav-mobile1").classList.remove("open");
                isText.value = false;
            }
            function OpenRightToggle() {
                isText.value = !isText.value;
                document.getElementById("menu").classList.remove("active-nav");
                isTextRed.value = false;
            }
            function CloseMenutoggle() {
                document.getElementById("nav-mobile1").classList.remove("open");
                isText.value = false;
                document.getElementById("menu").classList.remove("active-nav");
                isTextRed.value = false;
            }
            return {
                companyLogo: '',
                isscrolled: false,
                IsOpenRightMenu: false,
                isTextRed,
                isText,
                menutoggle,
                LanguageList: [],
                LanguageId: null,
                userId: localStorage.getItem("userId"),
                OpenRightToggle,
                CloseMenutoggle,
                currentSelectLang: ''
            }
        },
        created() {
            this.getCompanyLogo();
            this.getlanguageList();
            if (localStorage.getItem('Language') == 'en') {
                this.LanguageId = '364697eb-c5d6-44fa-8c08-ece45aed1844';
                this.currentSelectLang = "English"
            } else {
                this.LanguageId = 'cdf82d9b-07af-427e-9261-a3f45bc98f8f';
                this.currentSelectLang = "Spanish"
            }
        },

        mounted() {
            window.addEventListener('scroll', this.updateScroll);
        },
        methods: {
            ChangeLanguage(event) {
                this.currentSelectLang = event.text;
                var item = this.LanguageList.find(x => x.value == event.value);
                let model = {
                    userId: localStorage.getItem("userId"),
                    companyId: localStorage.getItem("companyId"),
                    SelectedLanguage: this.LanguageId
                }
                localStorage.removeItem("domain");
                localStorage.removeItem("Language");
                localStorage.removeItem("LanguageId");
                localStorage.setItem("Language", item.masterName);
                localStorage.setItem("languageId", item.value);
                this.$router.go(0);
                //UserService.UpdateLanguageId(model)
                //    .then(response => {
                //        //this.$toast.success("");
                //        localStorage.removeItem("Language");
                //        localStorage.setItem("Language", item.masterName);
                //        this.$router.go(0);
                //    });

            },
            getlanguageList() {
                if (this.userId == null || this.userId == undefined) {
                    this.userId = '00000000-0000-0000-0000-000000000000'
                }
                service.GetLanguageList('Language', 'Language', this.userId)
                    .then(response => {
                        this.LanguageList = response.data;



                    });
            },
            getCompanyLogo() {
                let logoUrl = localStorage.getItem('companySecondaryLogo') != null ? localStorage.getItem('companySecondaryLogo') : localStorage.getItem('companyLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo.png') : logoUrl;
            },
            OpenRightMenu() {
                this.IsOpenRightMenu = (this.IsOpenRightMenu) ? false : true;
                let navbar = document.getElementsByClassName("navbar-default");
                let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                let sectionFooter = document.getElementsByClassName("section-footer");
                let footerbottom = document.getElementById('footer-bottom');
                if (this.IsOpenRightMenu) {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.add("show-menu1");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.add("show-menu1");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.add("show-menu1");
                    }
                    // footerbottom.classList.add("show-menu1");
                } else {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu1");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu1");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu1");
                    }
                    //  footerbottom.classList.remove("show-menu1");
                }

            }, ToggleLeftMenu(Action = null) {
                this.IsOpenLeftMenu = (this.IsOpenLeftMenu) ? false : true;
                let navbar = document.getElementsByClassName("navbar-default");
                let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                let sectionFooter = document.getElementsByClassName("section-footer");
                let footerbottom = document.getElementById('footer-bottom');
                if (this.IsOpenLeftMenu) {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.add("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.add("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.add("show-menu");
                    }
                    //footerbottom.classList.add("show-menu");
                } else {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu");
                    }
                    //footerbottom.classList.remove("show-menu");
                }
            },
            CloseLeftMenu() {
                if (this.IsOpenLeftMenu) {
                    let navbar = document.getElementsByClassName("navbar-default");
                    let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                    let sectionFooter = document.getElementsByClassName("section-footer");

                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu");
                    }
                    this.IsOpenLeftMenu = false

                }

            },
            updateScroll() {
                this.scrollPosition = window.scrollY;
                if (this.scrollPosition != 0) {
                    this.isscrolled = true;
                }
                else {
                    this.isscrolled = false;
                }

            },
            goToPortalDashboard() {
                this.$emit('goToPortal')
            },
            logoutfrommenu() {
                this.$emit('logout');
            },

        }
    }
</script>
